module.exports = __webpack_public_path__ + "img/赵戌峰.5016a58c.jpg";